/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoResetStatsLogListResetStatsLogData model module.
 * @module model/LogControllerDtoResetStatsLogListResetStatsLogData
 * @version 1.0
 */
class LogControllerDtoResetStatsLogListResetStatsLogData {
    /**
     * Constructs a new <code>LogControllerDtoResetStatsLogListResetStatsLogData</code>.
     * @alias module:model/LogControllerDtoResetStatsLogListResetStatsLogData
     */
    constructor() { 
        
        LogControllerDtoResetStatsLogListResetStatsLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoResetStatsLogListResetStatsLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoResetStatsLogListResetStatsLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoResetStatsLogListResetStatsLogData} The populated <code>LogControllerDtoResetStatsLogListResetStatsLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoResetStatsLogListResetStatsLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('transactionNo')) {
                obj['transactionNo'] = ApiClient.convertToType(data['transactionNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoResetStatsLogListResetStatsLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoResetStatsLogListResetStatsLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoResetStatsLogListResetStatsLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} transactionNo
 */
LogControllerDtoResetStatsLogListResetStatsLogData.prototype['transactionNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoResetStatsLogListResetStatsLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoResetStatsLogListResetStatsLogData.prototype['email'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoResetStatsLogListResetStatsLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} level
 */
LogControllerDtoResetStatsLogListResetStatsLogData.prototype['level'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoResetStatsLogListResetStatsLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoResetStatsLogListResetStatsLogData;

